import { useState, type FormEvent } from 'react';
import { setupAdmin } from '../api';

export function Setup({ onDone }: { onDone: () => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setSubmitting(true);
    try {
      await setupAdmin({ username, password });
      onDone();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Setup failed');
      setSubmitting(false);
    }
  }

  const ready = username.trim().length >= 3 && password.length >= 8 && confirm.length >= 8;

  return (
    <div className="gate">
      <div className="gate-card">
        <div className="gate-brand">
          <span className="brand-mark" />
          <span className="brand-name">Operator</span>
        </div>
        <div className="eyebrow" style={{ marginTop: 20 }}>First-time setup</div>
        <h1 className="gate-title">
          Create your <em>admin</em> account.
        </h1>
        <p className="gate-sub">
          This is a one-time setup. The account you create here will be the only way
          into the dashboard.
        </p>

        <form className="gate-form" onSubmit={submit} autoComplete="off">
          <div className="field">
            <label className="field-label" htmlFor="u">Username</label>
            <input
              id="u"
              className="input input-mono"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              spellCheck={false}
              autoComplete="off"
            />
          </div>
          <div className="field">
            <label className="field-label" htmlFor="p">Password</label>
            <input
              id="p"
              className="input input-mono"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
            />
          </div>
          <div className="field">
            <label className="field-label" htmlFor="c">Confirm password</label>
            <input
              id="c"
              className="input input-mono"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoComplete="new-password"
            />
          </div>

          {error && <div className="form-error">{error}</div>}

          <div className="submit-row">
            <div className="submit-hint">Minimum 8 characters.</div>
            <button className="btn-primary" type="submit" disabled={!ready || submitting}>
              {submitting ? <span className="spinner" /> : null}
              {submitting ? 'Creating' : 'Create account →'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
